// Dev fallback only — real user data is sourced from Clerk's useUser() in
// production code paths. Used in pure-design routes (e.g., /dev/showcase) where
// auth state is irrelevant.
export const MOCK_USER = {
  name: "Juno Park",
  email: "juno@kirinbev.com",
  initials: "JP",
  org: "Kirin Beverage R&D",
  seat: "Lead Flavorist",
  defaultMachine: "agilent" as "agilent" | "thermo",
};
